const About = () => (
    <div id="about" className="row pt-5">
        <h6 className="fw-bold">ABOUT</h6>
        <p className="pt-4">
            I'm a Software Developer with a background in IT Operations, holding a B.Eng in Software Engineering. I'm passionate about IT, Software Engineering, learning and continuously developing my skills.
        </p>
        <img className="mt-5 d-md-none col-10 col-sm-8 mx-auto rounded-circle" src="/profile.JPEG" alt="Vetle L. Gundersen" />
    </div>
);

export default About;
